export default "/images/c8a2482e07f9a2ea46fcf77766c65cfa.png";